const BIKES_PENDING = 'bikes_pending';
const BIKES_FAILED = 'bikes_failed';
const BIKES_DOWNLOADED = 'bikes_downloaded';
const BIKES_RESET = 'bikes_reset';
const BIKE_SENDING = 'bike_sending';
const BIKE_DOWNLOADED = 'bike_downloaded';

export {
  BIKES_PENDING,
  BIKES_FAILED,
  BIKES_DOWNLOADED,
  BIKES_RESET,
  BIKE_SENDING,
  BIKE_DOWNLOADED,
};



// WEBPACK FOOTER //
// ./src/store/bikes/types.js